import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomLogisticsTable from "../../CustomLogisticsTable";
// import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import updateIcon from "../../../../../Assets/icons/check-circle (8) 1.svg";
import addIcon from "../../../../../Assets/icons/addIconLogistics.svg";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
// import DetailsTable from "./DetailsTable";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import DetailsTable from "../../PO Approval/PoApprovalDetails/DetailsTable";
// import { IoCheckmarkSharp } from "react-icons/io5";
// import PhysicalStockin from '../PhysicalStock-in';

import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import QuantityAdd from "../StockinComponents";
import MissingQty from "../StockinComponents/MissingQty";
import DamagedQty from "../StockinComponents/DamagedQty";
import Serial from "../../PhysicalStockTaking/PhysicalStockinComponents/Serial";
import StockInSerial from "../StockinComponents/StockInSerial";
import Loader from "../../../../customComponents/CustomLoader";

const StockInDetails = () => {
  const [poApprovalEdit, setPoApprovalEdit] = useState([]);
  const [poId, setPoId] = useState(0);
  const [formData, setFormData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [serialformData, setserialFormData] = useState({});
  const [loading, setLoading] = useState(true)
  const [activeComponent, setActiveComponent] = useState("");
  const stockinDrawerRadios = [
    { value: "inventory", label: "Stock In" },
    { value: "shortage", label: "Received Shortage" },
    { value: "damaged", label: "Defective Return" },
  ];

  console.log(stockinDrawerRadios, "DRAWERRADIOS")

  // useEffect(() => {

  // })

  const [ poIdValue, setPoValue  ] = useState()
  const [ poDetailsId, setPoDetailsId ] = useState()

  const [ showroomIdVal, setShowroomIdVal ] = useState()
  const [ pendingValData, setPendingValData ] = useState()
  const [ defectiveVal, setDefectiveQtyVal ] = useState()
  const [ missingQtyVal, setMissingQtyVal ] = useState()

  const [isEdit, setIsEdit] = useState(false);
  const [serialDrawer, setSerialDrawer] = useState(false);
  const [isSerailDrawerOpen, setIsSerialDrawerOpen] = useState(false);
  const [serialData,setSerialData] = useState([])

  // 2nd drawer
  const [serialStockInDrawer, setSerialStockInDrawer] = useState(false);
  const [isSerailIsStockInDrawerOpen, setIsSerialIsStockInDrawerOpen] = useState(false);

  const [ businessPartnerIdValue ,  setBusinessPartnerIdValue] = useState()
  
  const [editRowId, setEditRowId] = useState(null); // Track the row being edited
  const [editedQuantity, setEditedQuantity] = useState({}); // Track edited quantity for the specific row

  const [ activeBtn, setActiveBtn ] = useState("")

  const [ itemTypeValue, setItemTypevalue  ] = useState()

  const [editRow, setEditRow] = useState(null);

  const [ itemNameData, setItemNameData ] = useState("")
  //   const []

  const [businessPartnerIdState, setBusinessPartnerIdState] = useState(null);
  // const [PhysicalStockinId,setPhysicalStockinId] = useState(0)
  const [productdetails, setProductDetails] = useState([]);
  const token = localStorage.getItem("authToken");
  const [vendorId, setVendorId] = useState();
const navigate = useNavigate()
  const location = useLocation();
  const { data } = location.state || {};
  const PhysicalStockinId = data?.phystkin_id;
  console.log("locationdata<><><>", data);

  useEffect(() => {
    fetchPoApprovalDetailsEdit();
  }, []);

  const fetchPoApprovalDetailsEdit = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(
        `/purchaseorder/edit/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data;

      const showroomId = response.data.data.showroom_id
      console.log(showroomId, "showroomId")
      setShowroomIdVal(showroomId)

      console.log(fetchedData, "FETCHEDDATA");
      setPoApprovalEdit(fetchedData);
      const poIdVal = response.data.data.po_id;
      console.log(poIdVal, "POVALID");
      setPoId(poIdVal);

      console.log(formData, "depatartment DATA");
    } catch (error) {
      console.log(error);
    }
    finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    if (poId !== 0) {
      fetchProductDetails();
      
    }
  }, [poId, isSerailDrawerOpen, serialDrawer]);

  const fetchProductDetails = async (page = 0, pageSize = 5) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/podetails/list",
        {
          po_id: poId,
          orderBy: "po_details_id asc",
          listType: 'stockin',
          page,
          pageSize,
          fullamountrecived:1 
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data;
  
      console.log(formattedData, "formatdata");
      setProductDetails(formattedData);

      const quantities = formattedData.map((item) => item.po_details_id);
      console.log(quantities, "QuantValues");

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
    finally{
      setLoading(false)
    }
  };


  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Name",
    "Variant Name",
    "Product Name",
    "Make Name",
    
    "Quantity",
    "Missing Quantity",
    "Defective Quantity",
    "Pending Quantity",
    "Goods Quantity",
    "Price",
    "Tax",
    "Taxset Amount",
    "Total Price",
    "Action",

  ];

  const DEPARTMENT_KEY_MAPPING = {
    Name: "name",
    "Logistic Type": "itemtypename",
    "Product Name": "product_name",
    "Sub Product Name": "subproduct_name",
    "Make Name": "make_name",
    "Model Name": "model_name",
    "Variant Name": "variant_name",
    "Quantity": "accepted_qty",
    "Missing Quantity":"missing_qty",
    "Defective Quantity":"defective_qty",
    "Quantity Approved": "qty_approved",
    "Pending Quantity":"pendingqty",
    "Goods Quantity":"good_qty",
    "Price": "rate",
    "Tax": "tax",
    "Taxset Amount": "taxset_amount",
    "Total Price": "totalprice",
   'Action': [
    { type: "addserial", icon: editIcon, label: "Add" },
    { type: "addstockinserial", icon:addIcon , label: "AddStockIn" },
     
    ]
  };
 
  const handleEditClick = (row) => {
    console.log(row.po_details_id, "row");
   setEditRow(row.po_details_id)
    setEditRowId(row.po_details_id); // Set the specific row in edit mode
    setEditedQuantity({ [row.po_details_id]: row.qty_approved }); // Initialize with the current quantity for the specific row
  };
  const handleQuantityChange = (e, rowId) => {
    const newQuantity = e.target.value; // Capture the input as a string

    if (
      newQuantity === "" ||
      isNaN(newQuantity) ||
      parseInt(newQuantity) <= 0
    ) {
      // Handle invalid input case
      console.warn("Invalid quantity input:", newQuantity);
      setEditedQuantity({ ...editedQuantity, [rowId]: newQuantity }); // Still update the state with the current input
      return;
    }

    // Convert the input to an integer after validation
    const validQuantity = parseInt(newQuantity, 10);

    // Find the row in productdetails to calculate new values
    const rowToUpdate = productdetails.find(
      (item) => item.po_details_id === rowId
    );
    console.log(rowToUpdate, "ROWTOUPDATE");

    if (rowToUpdate) {
      const rate = parseFloat(rowToUpdate.rate) || 0; // Convert to float, default to 0 if NaN
      const tax = parseFloat(rowToUpdate.tax) || 0; // Convert to float, default to 0 if NaN

      // Recalculate the total price and tax amount
      const total = validQuantity * rate;
      console.log(total, "TOTALVALUE");
      const taxAmountValue = total * tax;

      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;

      // Update the state with the new calculated values
      setProductDetails((prevDetails) =>
        prevDetails.map((item) =>
          item.po_details_id === rowId
            ? {
                ...item,
                qty_approved: validQuantity,
                totalprice: newTotalPrice,
                taxset_amount: newTaxAmount,
              }
            : item
        )
      );

      setEditedQuantity({ ...editedQuantity, [rowId]: validQuantity }); // Update the quantity for the specific row
    }
  };

  const handleSave = async (row) => {
    
    console.log(
      "Saving Quantity for row:",
      row.po_details_id,
      "New Quantity:",
      editedQuantity[row.po_details_id]
    );

    const rowToUpdate = productdetails.find(
      (item) => item.po_details_id === row.po_details_id
    );

    if (rowToUpdate) {
      const newQuantity = editedQuantity[row.po_details_id];

      const total = newQuantity * rowToUpdate.rate;
      const taxAmountValue = total * rowToUpdate.tax;
      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;

      // Prepare payload for saving
      const payload = {
        qty_approved: newQuantity,
        totalprice: String(newTotalPrice),
        taxset_amount: String(newTaxAmount),
      };

      try {
        const response = await axiosInstance.patch(
          `/purchaseorderapproval/update/${row.po_details_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response, "EDITQUANTRESPONSE");

        setProductDetails((prevDetails) =>
          prevDetails.map((item) =>
            item.po_details_id === row.po_details_id
              ? {
                  ...item,
                  qty_approved: newQuantity,
                  totalprice: newTotalPrice,
                  taxset_amount: newTaxAmount,
                }
              : item
          )
        );
      } catch (error) {
        console.log(error);
      }

      // After saving, reset the edit state
      setEditRowId(null);
    }
  };

  const toggleSerialDrawer = () => {
    console.log("isSerailDrawerOpen",isSerailDrawerOpen);
    setIsSerialDrawerOpen((prevState) => !prevState);

    setFormData({})
    fetchProductDetails()
    
  };

   const toggleSerialStockInDrawer = () => {
    console.log("factoryDrawer");
    setIsSerialIsStockInDrawerOpen((prevState) => !prevState);
    fetchProductDetails()
    setFormData({})
   }

   const handleStockInAddSerial = (rowData) => {
    setSerialStockInDrawer(true)
    toggleSerialStockInDrawer();
    setPoDetailsId(rowData?.po_details_id)
    console.log("rowData1>>", rowData);
   }

  const handleAddSerial = (rowData) => {
    console.log("rowData2>>", rowData);
    const pendingQty = rowData.pendingqty
      const missingQty = rowData.missing_qty
      setMissingQtyVal(missingQty)

      const defectiveQty = rowData.defective_qty;
      setDefectiveQtyVal(defectiveQty)
      const substractedQty = pendingQty - missingQty

      const itemType = rowData.itemtype
      setItemTypevalue(itemType)

      const businessPartnerId = rowData.business_partner_id
      setBusinessPartnerIdValue(businessPartnerId)

      console.log(substractedQty, "SUBSTRACTEDQTY")
      console.log(pendingQty,"PendingQty")
      setPendingValData(substractedQty)

      const poIdValueData = rowData.po_id
      setPoValue(poIdValueData)

      const poDetailsId = rowData.po_details_id
      setPoDetailsId(poDetailsId)

      const itemNameType = rowData.itemtypename
      setItemNameData(itemNameType)
      

    toggleSerialDrawer()
    setSerialData(rowData)

    setSerialDrawer(true);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductDetails(newPage);
  };

  useEffect(() => {
    console.log(pendingValData, defectiveVal, missingQtyVal, "datavalues")
    
    if (pendingValData >0) {
      console.log("inventory", );
      // setActiveBtn("inventory");
      setActiveComponent("inventory");
    } else if (defectiveVal === 1) {
      console.log("damaged");
      // setActiveBtn("damaged");
      setActiveComponent("damaged");
    } else if (missingQtyVal === 1) {
      console.log("shortage");
      // setActiveBtn("shortage");
      setActiveComponent("shortage");
    }
  }, [pendingValData, defectiveVal, missingQtyVal]);

console.log(activeComponent, "Activecomponent")

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className="">
        <div
          style={{
            paddingBottom: "35px",
            borderBottom: "1px solid lightgray",
            padding: "35px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <span
              style={{
                fontWeight: "300",
                fontSize: "12px",
                paddingBottom: "5px",
                color: "gray",
                paddingLeft: "15px",
              }}
            >
              Sales / Stock-In / Stock-In Details
            </span>
            <div className="backbutton" onClick={()=>navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitleDetails"> Stock-In Details</span>
            </div>
          </div>
        
        </div>

        <div>
          <div className="">
            <h5
              style={{ paddingLeft: "55px" }}
              className="mt-2 mb-2 header-details"
            >
              Details
            </h5>
            <div
              className="detail-grid"
              style={{
                paddingBottom: "30px",
                borderBottom: "1px solid lightgray",
                paddingLeft: "57px",
                paddingTop: "15px",
              }}
            >
              <div className="details-item">
                <span className="details-label">PO Number</span>
                <span className="details-value">
                  {" "}
                  {poApprovalEdit.po_number}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">PO Date</span>
                <span className="details-value">{poApprovalEdit.po_date} </span>
              </div>
              <div className="details-item">
                <span className="details-label">Purchase Order Type</span>
                <span className="details-value">{poApprovalEdit.po_type} </span>
              </div>
              <div className="details-item">
                <span className="details-label">Vendor Name</span>
                <span className="details-value">
                  {poApprovalEdit.companyname}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Ref. No.</span>
                <span className="details-value">
                  {poApprovalEdit.reference_no}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Department</span>
                <span className="details-value">
                  {poApprovalEdit.department_name}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Term</span>
                <span className="details-value">
                  {poApprovalEdit.payment_term_name}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Type</span>
                <span className="details-value">
                  {poApprovalEdit.payment_mode}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">PO Expected Date</span>
                <span className="details-value">
                  {poApprovalEdit.po_expected_date}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Date</span>
                <span className="details-value">
                  {poApprovalEdit.payment_date}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Total</span>
                <span className="details-value">{poApprovalEdit.total} </span>
              </div>
            </div>

            {serialDrawer && (
          <Drawer
            size={700}
            open={isSerailDrawerOpen}
            onClose={toggleSerialDrawer}
            direction="right"
            className="bla bla bla"
          >
            <div style={{ padding: "30px" }}>
              <div className="backbutton" onClick={()=>toggleSerialDrawer()}>
                <img src={backicon} alt="back" />
                <span className="backbtntitleDetails">
                  Purchase Stock-In 
                </span>
              </div>
              <hr />
              <div
                className="d-flex jus align-items-center pt-3 flex-row gap-4"
                style={{ paddingLeft: "20px" }}
              >
                {stockinDrawerRadios
                  .filter(option => {
                    
                    if (pendingValData === 0 && option.value === "inventory") {
                      // setActiveComponent()
                      console.log(option.label, "inventory")
                      // setActiveBtn(option.value)
                      return false; // Hide "Stock In" when pendingValData is 0
                    }
                    if (defectiveVal === 0 && option.value === "damaged") {
                      // setActiveComponent("damaged")
                      console.log(option.label, "damaged")
                      // setActiveBtn(option.value)
                      return false; // Hide "Damaged" when defectiveQty is 0
                    }
                    if (missingQtyVal === 0 && option.value === "shortage") {
                      // setActiveComponent("shortage")
                      // setActiveBtn(option.value)
                      console.log(option.label,"shortage" )
                      return false; 
                    }
                    return true; // Show all other options
                  })
                  .map((option, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                      }}
                      onClick={() => {
                        setActiveComponent(option.value);
                      }}
                    >
                      <input
                        type="radio"
                        name="activeComponent"
                        checked={activeComponent === option.value}
                        onChange={() => setActiveComponent(option.value)}
                        className="form-check-input"
                      />
                      {option.label}
                    </div>
                ))}
              </div>
              <div className="mt-3">
              {activeComponent === "shortage" && (
                  <div className="mt-3">
                    <MissingQty
                      showroomIdVal={showroomIdVal}
                      pendingValData={missingQtyVal}
                      poIdValue={poIdValue}
                      poDetailsId={poDetailsId}
                      setSerialDrawer={setSerialDrawer}
                      activeComponent={"shortage"}
                      isSerailDrawerOpen={isSerailDrawerOpen}
                      // toggleDrawer={toggleDrawer}
                      // missingQtyVal={missingQtyVal}
                      businessPartnerIdState={businessPartnerIdState}
                    />
                  </div>
                )}
                {activeComponent === "damaged" && (
                  <div className="mt-3">
                    <DamagedQty
                      showroomIdVal={showroomIdVal}
                      pendingValData={defectiveVal}
                      poIdValue={poIdValue}
                      poDetailsId={poDetailsId}
                      setSerialDrawer={setSerialDrawer}
                      activeComponent={"damaged"}
                      // toggleDrawer={toggleDrawer}
                      isSerailDrawerOpen={isSerailDrawerOpen}
                      businessPartnerIdState={businessPartnerIdState}
                    />
                  </div>
                )}
                {activeComponent === "inventory" && (
                  <div className="mt-3">
                    <QuantityAdd
                showroomIdVal={showroomIdVal}
                pendingValData={pendingValData}
                poIdValue={poIdValue}
                poDetailsId={poDetailsId}
                activeComponent={"inventory"}
                isSerailDrawerOpen={isSerailDrawerOpen}
                setSerialDrawer={setSerialDrawer}
                />
                  </div>
                )}
              </div>
             
            
            </div>
          </Drawer>
        )}

{/* 2nd Serial Drawer */}
{serialStockInDrawer && (
          <Drawer
            size={800}
            open={isSerailIsStockInDrawerOpen}
            onClose={toggleSerialStockInDrawer}
            direction="right"
            className="bla bla bla"
          >
            <div style={{ padding: "30px" }}>
              <div className="backbutton">
                <img src={backicon} alt="back" />
                <span className="backbtntitleDetails">
                  Add Factory Stock-In Serial 
                </span>
              </div>

              <div className="mt-3">
                <StockInSerial
                  // PhysicalStockinId={PhysicalStockinId}
                  // vendorId={vendorId}
                  // fetchDepartments={fetchDepartments}
                  // isEdit={isEdit}
                  isSerailDrawerOpen={isSerailIsStockInDrawerOpen}
                  toggleSerialDrawer={toggleSerialStockInDrawer}
                  businessPartnerIdValue={businessPartnerIdValue}
                  // phyItemId={phyItemId}
                  poIdValue={poIdValue}
                  serialData={serialData}
                  setIsEdit={setIsEdit}
                  serialformData={serialformData}
                  setserialFormData={setserialFormData}
                  showroomIdVal={showroomIdVal}
                  itemTypeValue={itemTypeValue}
                  itemNameData={itemNameData}
                  // itemNameData={itemNameData}
                  formData={formData}
                  setFormData={setFormData}
                  businessPartnerIdState={businessPartnerIdState}
                  poDetailsId={poDetailsId}
                />
              </div>
              <hr />
            
            </div>
          </Drawer>
        )}

            <div style={{ paddingTop: "14px" }}>
              <CustomLogisticsTable
                data={productdetails}
                headers={DEPARTMENT_TABLE_HEADERS}
                keyMapping={DEPARTMENT_KEY_MAPPING}
                itemsPerPage={10}
                onPageChange={handlePageChange}
                updateIcon={updateIcon}
                onAddSerial={handleAddSerial}
                onAddStockInSerial={handleStockInAddSerial}
                totalRecords={totalRecords} 
                currentPage={currentPage}
          totalPages={totalPages}
              />
            </div>
          </div>
        </div>
      </div>
      </div>
    )}
    </div>
  );
};

export default StockInDetails;
